<template>
  <!-- 回显参数 -->
	<div class="image-upload-multiple" style="">
    <div v-if="itemActivityForm" class="pb8">
      <el-button  type="primary" size="mini" icon="el-icon-plus" @click="handUpload">上传图片</el-button>
    </div>
		<el-upload
      v-else
			ref="uploader"
			:auto-upload="autoUpload"
			:disabled="disabled"
			:action="action"
			:name="name"
			:data="data"
			:http-request="request"
      :file-list="defaultFileList"
			:show-file-list="false"
			:accept="accept"
			:multiple="multiple"
			:limit="limit"
			:before-upload="before"
      :on-remove="remove"
			:on-success="success"
			:on-error="error"
			:on-preview="handlePreview"
			:on-exceed="handleExceed"
		>
			<slot>
        <!-- <i class="el-icon-plus"></i> -->
        <el-button type="primary" size="mini" icon="el-icon-plus" >上传图片</el-button>
			</slot>
			<template #tip>
				<div v-if="tip" class="el-upload__tip">{{ tip }}</div>
			</template>
			
		</el-upload>
    <div>
      <vxe-table
          border
          ref="xTree"
          :data="defaultFileList"
          :row-config="{useKey:'id',keyField:'id'}"
          :edit-config="{trigger: 'manual', mode: 'row', autoClear: false}"
          max-height="700px"
          >
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column align="center" width="120"  field="url" title="图片">
            <template  #default="{ row }">
              <template v-if="row.url">
                <div class="imageBox">
                  <el-popover
                    placement="right"
                    width="400"
                    trigger="hover">
                      <div class="popoverBox">
                        <el-image  :src="setUrlHearder(row.url)" style="width: 380px;" fit="cover" ></el-image>
                      </div>
                      <el-image
                        slot="reference"
                        style="height: 100px;width:100px;margin:10px 0"
                        :src="setUrlHearder(row.url)"
                        :ref="`previewImg_`"
                        @click="handImage"
                        :preview-src-list="[setUrlHearder(row.url)]">
                      </el-image>
                  </el-popover>
                </div>
              </template>
            </template>
          </vxe-column>
          <vxe-column
            field="name"
            align="center"
            min-width="200"
            :edit-render="{placeholder: '请输入'}"
            title="名称">
            <template #edit="{ row, rowIndex }">
              <el-input v-model="row.name" style="width: 100%;" placeholder="请输入内容" @input="handName(row,rowIndex)"></el-input>
              <!-- <el-button
                type="success"
                plain
                size="small"
                icon="el-icon-check"
                @click="saveRowEvent(row)"
              ></el-button> -->
            </template>
          </vxe-column>
          <vxe-column
            field="fileSize"
            align="center"
            width="80"
            title="大小">
            <template  #default="{ row }">
              <span>{{ backSize(row.fileSize) }}</span>
            </template>
          </vxe-column>
          <vxe-column
            v-if="!setTable"
            field="pixel"
            align="center"
            width="130"
            title="像素">
          </vxe-column>
          <!-- <vxe-column
            field="url"
            align="center"
            title="路径">
          </vxe-column> -->
          <vxe-column
            v-if="!setTable"
            field="createDate"
            align="center"
            width="150"
            title="上传时间">
          </vxe-column>
          <vxe-column
            v-if="!setTable"
            field="actorName"
            align="center"
            width="100"
            title="操作人">
          </vxe-column>
          <vxe-column v-if="setTable" sortable field="description" title="描述" :edit-render="{placeholder: '请输入'}">
            <template #edit="{ row, rowIndex }">
              <el-input v-model="row.description" style="width: 100%;" placeholder="请输入描述" @input="handDescription(row,rowIndex)"></el-input>
            </template>
          </vxe-column>
          <vxe-column
            fixed="right"
            align="center"
            width="150"
            title="操作">
            <template  #default="{ row, rowIndex }">
              <template v-if="$refs.xTree.isEditByRow(row)">
                <el-button type="text" icon="el-icon-check" style="color: #67c23a;" @click="updateFileName(row, rowIndex)">保存</el-button>
                <el-button type="text" icon="el-icon-close" style="color: red;" @click="cancelRowEvent(row)">取消</el-button>
              </template>
              <template v-else>
                <el-button type="text" icon="el-icon-edit" @click="editRowEvent(row)">编辑</el-button>
                <el-button  type="text"  icon="el-icon-delete" size="small" @click="handleRemove(row)">删除</el-button>
              </template>
            </template>
          </vxe-column>
        </vxe-table>
    </div>
		<span style="display: none !important"
			><el-input v-model="value"></el-input
		></span>
    <!-- 弹窗, 新增 / 修改 -->
    <itemActivityForm
      ref="itemActivityForm"
      :ifDescription="!setTable"
      :ifSetUploadName="ifSetUploadName"
      @doSubmitList="doSubmitList"
    ></itemActivityForm>
	</div>
</template>

<script>
import config from './config'
import Sortable from 'sortablejs'
import _ from 'lodash'
import itemActivityForm from '@/components/file/itemActivityForm'
// import cecUnmFileService from '@/api/unmfile/cecUnmFileService'
export default {
  props: {
    modelValue: { type: Array, default: () => [] },
    otherPrams: { type: Object, default: () => {} },
    tip: { type: String, default: '' },
    action: { type: String, default: '' },
    apiObj: { type: Object, default: () => {} },
    name: { type: String, default: config.filename },
    data: { type: Object, default: () => {} },
    accept: { type: String, default: 'image/gif, image/jpeg, image/png' },
    maxSize: { type: Number, default: config.maxSize },
    limit: { type: Number, default: 0 },
    autoUpload: { type: Boolean, default: true },
    showFileList: { type: Boolean, default: true },
    multiple: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    draggable: { type: Boolean, default: false },
    setTable: { type: Boolean, default: false },
    itemActivityForm: {type: Boolean, default: false},
    ownerId: { type: String, default: '' },
    uploadInfo: { type: Object, default: () => {} },
    ifSetUploadName: {type: Boolean, default: false},
    onSuccess: {
      type: Function,
      default: () => {
        return true
      }
    }
  },
  data () {
    return {
      value: '',
      defaultFileList: [],
      sortTableRef: null,
      itemActivityList: [],
      oldClickRow: null
    }
  },
  components: {
    itemActivityForm
  },
  // 超级牛
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  watch: {
    modelValue (val) {
      // if (val !== this.toStr(this.defaultFileList)) {
      this.defaultFileList = []
      this.defaultFileList = this.toArr(JSON.parse(JSON.stringify(val)))
      this.itemActivityList = this.toArr(JSON.parse(JSON.stringify(val)))
      this.value = val
      // }
    },
    defaultFileList: {
      handler (val) {
        // this.$emit('change', val)
        this.$emit('changeLisy', val)
        this.value = this.toStr(val)
      },
      deep: true
    },
    disabled: {
      handler (val) {
        if (val && this.draggable) {
          if (this.sortTableRef) {
            this.sortTableRef.options.disabled = true
          }
        } else {
          if (this.draggable) {
            // this.sortTableRef.options.disabled = false
            this.rowDrop()
          }
        }
      }
    }
  },
  computed: {
    preview () {
      return this.defaultFileList.map((v) => v.url)
    }
  },
  mounted () {
    this.value = this.modelValue
    this.defaultFileList = this.toArr(this.modelValue)
    this.itemActivityList = this.toArr(this.modelValue)
    if (!this.disabled && this.draggable) {
      this.rowDrop()
    }
  },
  methods: {
    // 编辑行
    editRowEvent (row) {
      if (!this.oldClickRow === false && row.filePath !== this.oldClickRow.filePath) {
        this.$refs.xTree.isEditByRow(this.oldClickRow)
        return
      }
      this.oldClickRow = row
      const $table = this.$refs.xTree
      $table.setEditRow(row)
      if (this.sortTableRef) {
        this.sortTableRef.options.disabled = true
      }
    },
    saveRowEvent (row) {
      const $table = this.$refs.xTree
      // 清除编辑状态
      $table.clearEdit().then(() => {
        // this.$emit('updateDet')
        if (this.sortTableRef) {
          this.sortTableRef.options.disabled = false
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    cancelRowEvent (row) {
      const $table = this.$refs.xTree
      $table.clearEdit().then(() => {
        // 还原行数据
        let findData = this.itemActivityList.find(item => item.filePath === row.filePath)
        row.name = findData.name
        row.description = findData.description
        this.oldClickRow = null
        $table.revertData(row)
        if (this.sortTableRef) {
          this.sortTableRef.options.disabled = false
        }
      })
    },
    // 修改附件名称
    async updateFileName (row, rowIndex) {
      this.itemActivityList[rowIndex].description = row.description
      if (row.name === this.itemActivityList[rowIndex].name) {
        this.oldClickRow = null
        this.saveRowEvent(row)
        return
      }
      var apiObj = config.apiObj
      var urlArr = row.filePath.split('&name=')
      var fileName = urlArr[urlArr.length - 1]
      let type = this.getFileExtension(fileName, 'subEnd')
      let params = {
        filePath: row.filePath,
        fileName: row.name + type,
        id: row.id.indexOf('row') >= 0 ? '' : row.id
      }
      await apiObj.updateFileName(params).then((res) => {
        let result = res.data
        if (result.state === '200') {
          this.oldClickRow = null
          row.url = process.env.VUE_APP_SERVER_URL + result.filePath
          row.filePath = result.filePath
          this.itemActivityList[rowIndex].url = process.env.VUE_APP_SERVER_URL + result.filePath
          this.itemActivityList[rowIndex].filePath = result.filePath
          this.itemActivityList[rowIndex].name = row.name
          this.$emit('updateChange', this.itemActivityList)
          this.saveRowEvent(row)
        } else {
          this.$message.error(result.msg)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getFileExtension (fileName, type) {
      // 使用 lastIndexOf 方法找到最后一个点的位置
      let lastDotIndex = fileName.lastIndexOf('.')
      // 如果没有找到点，返回空字符串或适当的默认值
      if (lastDotIndex === -1) return ''
      // 截取从点到字符串末尾的部分作为扩展名
      let extension = ''
      if (type === 'subEnd') {
        extension = fileName.substring(lastDotIndex)
      } else {
        extension = fileName.substring(0, lastDotIndex)
      }
      return extension
    },
    handImage () {
      console.log(this.$refs.previewImg_)
    },
    // 点击上传
    handUpload () {
      if (this.ifSetUploadName && !this.uploadInfo.fileName) {
        this.$message.error(this.uploadInfo.tip)
        return false
      }
      if (this.defaultFileList.length > 0) {
        this.$refs.itemActivityForm.init('edit', this.ownerId, this.itemActivityList, this.uploadInfo)
      } else {
        this.$refs.itemActivityForm.createNewRecordForOwnerId(this.uploadInfo)
      }
    },
    doSubmitList (data) {
      this.defaultFileList = JSON.parse(JSON.stringify(data))
      this.itemActivityList = JSON.parse(JSON.stringify(data))
      this.$emit('updateChange', data)
    },
    handName: _.debounce(function (e, index) {
      // this.itemActivityList[index].name = e.name
    }, 100),
    handDescription: _.debounce(function (e, index) {
      // this.itemActivityList[index].description = e.description
      // this.$emit('updateChange', (this.defaultFileList))
    }, 500),
    backSize (e) {
      let fileSize = Number(e) / 1024
      return fileSize.toFixed(1) + 'kb'
    },
    // 拼接url
    setUrlHearder (url) {
      return url.indexOf('http') >= 0 ? url : process.env.VUE_APP_SERVER_URL + url
    },
// 默认值转换为数组
    toArr (str) {
      var _arr = str.map(item => {
        // var urlArr = item.filePath.split('&name=')
        // var fileName = urlArr[urlArr.length - 1]
        let ch = {
          id: item.id,
          name: item.name,
          url: item.filePath.includes('http') ? item.filePath : process.env.VUE_APP_SERVER_URL + item.filePath,
          filePath: item.filePath,
          fileSize: item.fileSize,
          description: item.description,
          actorId: item.actorId,
          actorName: item.actorName,
          startTime: item.startTime,
          categoryName: item.categoryName,
          category: item.category,
          createDate: item.createDate,
          pixel: item.pixel
        }
        return ch
      })
      // var arr = str.split(',')
      // arr.forEach((item) => {
      //   if (item) {
      //     var urlArr = item.split('&name=')
      //     var fileName = urlArr[urlArr.length - 1]
      //     _arr.push({
      //       name: fileName,
      //       url: process.env.VUE_APP_SERVER_URL + item
      //     })
      //   }
      // })
      return _arr
    },
// 数组转换为原始值
    toStr (arr) {
      return arr.map((v) => v.url).join(',')
    },
    toIdStr (arr) {
      return arr.map((v) => v.id).join(',')
    },
// 拖拽
    async rowDrop () {
      const _this = this
      const itemBox = this.$refs.xTree.$el.querySelectorAll(
        '.vxe-table--body-wrapper > table > tbody'
      )[0]
      this.sortTableRef = await Sortable.create(itemBox, {
        // handle: '.vxe-body--row',
        animation: 200,
        ghostClass: 'ghost',
        onEnd ({ newIndex, oldIndex }) {
          const tableData = _this.defaultFileList
          const currRow = tableData.splice(oldIndex, 1)[0]
          tableData.splice(newIndex, 0, currRow)
          const itemDate = _this.itemActivityList
          const currRow2 = itemDate.splice(oldIndex, 1)[0]
          itemDate.splice(newIndex, 0, currRow2)
          _this.$emit('updateChange', _this.itemActivityList)
        }
      })
    },
    before (file) {
      if (!['image/jpeg', 'image/png', 'image/gif'].includes(file.type)) {
        this.$message.warning(`选择的文件类型 ${file.type} 非图像类文件`)
        return false
      }
      const maxSize = file.size / 1024 / 1024 < this.maxSize
      if (!maxSize) {
        this.$message.warning(`上传文件大小不能超过 ${this.maxSize}MB!`)
        return false
      }
    },
    success (res, file, fileList) {
      var os = this.onSuccess(res, file)
      if (os !== undefined && os === false) {
        return false
      }
      var response = config.parseData(res)
      if (response.src !== undefined) {
        file.url = response.src.data
        this.defaultFileList = fileList.map(item => {
          if (item.raw) {
            item.id = ''
          }
          return item
        })
        this.itemActivityList = fileList.map(item => {
          if (item.raw) {
            item.id = ''
          }
          return item
        })
        this.$emit('updateChange', this.itemActivityList)
      }
    },
    remove (file, fileList) {
      this.defaultFileList = fileList
      // cecUnmFileService.delete(file.id).then(({data}) => {
      //   this.$emit('updateChange', this.toIdStr(this.defaultFileList))
      // }).catch(() => {
      // })
    },
    error (err) {
      this.$notify.error({
        title: '上传文件未成功',
        message: err
      })
    },
    beforeRemove (uploadFile) {
      return this.$confirm(`是否移除 ${uploadFile.name} ?`, '提示', {
        type: 'warning'
      }).then(() => {
        return true
      }).catch(() => {
        return false
      })
    },
    handleRemove (file) {
      if (this.itemActivityForm) {
        this.defaultFileList.splice(this.defaultFileList.findIndex(item => this.isBlankUid(item, file)), 1)
        this.itemActivityList.splice(this.itemActivityList.findIndex(item => this.isBlankUid(item, file)), 1)
      } else {
        this.$refs.uploader.handleRemove(file)
        this.itemActivityList.splice(this.itemActivityList.findIndex(item => this.isBlankUid(item, file)), 1)
      }
      this.$emit('updateChange', this.itemActivityList)
    },
    isBlankUid (file1, file2) {
      if (file1.uid) {
        return file1.uid === file2.uid
      } else {
        return file1.id === file2.id
      }
    },
    handleExceed () {
      this.$message.warning(`当前设置最多上传 ${this.limit} 个文件，请移除后上传!`)
    },
    handlePreview (uploadFile) {
      window.open(uploadFile.url)
    },
    async request (param) {
      var apiObj = config.apiObj
      if (this.apiObj) {
        apiObj = this.apiObj
      }
      const data = new FormData()
      data.append(param.filename, param.file)
      for (const key in param.data) {
        data.append(key, param.data[key])
      }
      let params = {
        id: this.otherPrams.id,
        type: this.otherPrams.type,
        uploadPath: 'userdir'
      }
      await apiObj.uploadFileUrl(data, params, {onUploadProgress: (e) => {
        const complete = parseInt(((e.loaded / e.total) * 100) | 0, 10)
        param.onProgress({ percent: complete })
      }
      }).then((res) => {
        param.onSuccess(res)
      }).catch((err) => {
        param.onError(err)
      })
    }
  }
}
</script>

<style scoped>
.el-form-item.is-error .image-upload-multiple:deep(.el-upload--picture-card) {
	border-color: var(--el-color-danger);
}
:deep(.el-upload-list__item) {
	transition: none;
	border-radius: 0;
}
.image-upload-multiple:deep(.el-upload-list__item.el-list-leave-active) {
	position: static !important;
}
.image-upload-multiple:deep(.el-upload--picture-card) {
	border-radius: 0;
}
.image-upload-list-item {
	width: 100%;
	height: 100%;
	position: relative;
}
.image-upload-multiple .el-image {
	display: block;
}
.image-upload-multiple .el-image:deep(img) {
	-webkit-user-drag: none;
}
.image-upload-multiple-image-slot {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	font-size: 12px;
}
.image-upload-multiple .el-upload-list__item:hover .image-upload__item-actions {
	display: block;
}
.image-upload__item-actions {
	position: absolute;
	top: 0;
	right: 0;
	display: none;
}
.image-upload__item-actions span {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 25px;
	height: 25px;
	cursor: pointer;
	color: #fff;
}
.image-upload__item-actions span i {
	font-size: 12px;
}
.image-upload__item-actions .del {
	background: #f56c6c;
}
.image-upload__item-progress {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: var(--el-overlay-color-lighter);
}
.imageBox{
  width: 100%;
  display: flex;
  justify-content: center;
}
::v-deep .el-image-viewer__img{

width: 50% !important;

height: auto !important;

}
.popoverBox{
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>
